import axios from '@/axios'

const PLANTING_BASE_PREFIX = '/api/screen-config/planting-base'

export const fetchPlantingBaseList = (params = {}) => {
  return axios.post(`${PLANTING_BASE_PREFIX}/list-page`, params)
}

export const addPlantingBase = (payload) => {
  if (!payload || typeof payload !== 'object') {
    return Promise.reject(new Error('payload is required'))
  }
  return axios.post(`${PLANTING_BASE_PREFIX}/add`, payload)
}

export const editPlantingBase = (payload) => {
  if (!payload || typeof payload !== 'object') {
    return Promise.reject(new Error('payload is required'))
  }
  return axios.post(`${PLANTING_BASE_PREFIX}/edit`, payload)
}

export const getPlantingBaseDetail = (id) => {
  if (!id && id !== 0) {
    return Promise.reject(new Error('planting base id is required'))
  }
  return axios.post(`${PLANTING_BASE_PREFIX}/detail/${id}`)
}

export const deletePlantingBase = (id) => {
  if (!id && id !== 0) {
    return Promise.reject(new Error('planting base id is required'))
  }
  return axios.post(`${PLANTING_BASE_PREFIX}/delete/${id}`)
}

